import crypto from 'crypto';
import { get } from 'lodash';

import env from '../config/env.json';

const getType = () => {
  return process.env.REACT_APP_MODE || 'development';
};

const alg = 'aes-256-cbc';
const key =
  get(process, 'env.ENCRYPTION_KEY') ||
  get(process, 'env.REACT_APP_ENCRYPTION_KEY') ||
  get(env, `crypt.${getType()}.key`);

const iv =
  get(process, 'env.ENCRYPTION_IV') ||
  get(process, 'env.REACT_APP_ENCRYPTION_IV') ||
  get(env, `crypt.${getType()}.iv`);

export const encrypt = text => {
  if (!key || !iv) throw new Error('Provide an encryption key and iv');

  const cipher = crypto.createCipheriv(
    alg,
    Buffer.from(key, 'hex'),
    Buffer.from(iv, 'hex'),
  );

  let encrypted = cipher.update(text);
  encrypted = Buffer.concat([encrypted, cipher.final()]);

  return encrypted.toString('hex');
};

export const decrypt = text => {
  if (!key || !iv) throw new Error('Provide an encryption key and iv');

  const encryptedText = Buffer.from(text, 'hex');
  const decipher = crypto.createDecipheriv(
    alg,
    Buffer.from(key, 'hex'),
    Buffer.from(iv, 'hex'),
  );

  let decrypted = decipher.update(encryptedText);
  decrypted = Buffer.concat([decrypted, decipher.final()]);

  return decrypted.toString();
};



// WEBPACK FOOTER //
// ./src/util/crypt.js